import ApiService from '../api.service'

export type NotificationVisualMode = 'toast' | 'modal' | 'badge'
export type NotificationSeverity = 'info' | 'success' | 'warning' | 'error'
type JsonValue =
    | string
    | number
    | boolean
    | null
    | { [key: string]: JsonValue }
    | JsonValue[]

export type NotificationSilentMessage = {
    id: string
    mode: 'silent'
    module: string
    type: string
    body: JsonValue
    createdAt?: string
}

export type NotificationVisualMessage = {
    id: string
    title: string
    message: string
    onClickUrl?: string
    severity?: NotificationSeverity
    mode: NotificationVisualMode[]
    createdAt?: string
    /** Presente apenas quando a notificação vem de uma campanha. */
    campanhaId?: string
    /** Corpo markdown exibido no modal rico. */
    corpoMarkdown?: string
    /** Botão primário do modal. */
    botao?: { label: string; url: string }
}

export type NotificationMessage =
    | NotificationSilentMessage
    | NotificationVisualMessage

const missed = new ApiService<never>('notifications/missed')

export const campanhas_ciencia = new ApiService<never>('campanhas')

const service = new ApiService<NotificationMessage>('notifications')

export const notificacoes_api = Object.assign(service, {
    missed,
})
